<template>
  <section v-if="collection" id="items" class="collection--items">
    <header>
      <h2 class="h5">{{title}}</h2>
      <template v-if="!options.isPurchase || readMore == true">
        <div class="textbody" v-html="text"></div>
        <div class="spacer" v-if="readMore"></div>
      </template>
      <template v-else-if="text">
        <button @click="readMore = !readMore">
          <span class="h6 readmore">Read Description</span>
        </button>
      </template>
    </header>
    
    <ul>
      <li v-for="product in products">
        <sku-item :product="product" :viewName="itemViewName" :isPurchase="options.isPurchase" :collectionSlug="slug"></sku-item>
      </li>
    </ul>
    <footer>
      <template v-if="cart !== null && this.cart.lineItemCount > 0">
        <a id="placeOrderBtn" :href="this.cart.checkoutUrl" class="enquire-btn century-mono">
          <span class="h5">CHECKOUT</span>
        </a>
      </template>
      <template v-else>
        <template v-if="options.customOrders">
          <a id="enquireBtn" v-show="products.length > 0" :href="'mailto:'+email" target="_blank" class="enquire-btn century-mono">
            <span class="h5 label">CUSTOM ORDERS</span>
            <div class="h8">For purchasing options<br> and bespoke enquiries please<br> contact us here.</div>
          </a>
        </template>
      </template>
    </footer>
    <transition name="fade">
      <router-view :products="products" :collectionTitle="shortTitle"></router-view>
    </transition>
    <div v-if="slug === 'bespoke-service' && collections.length && collections[0].data['collection.items--enquire-email']">
      <a :href="'mailto:' + collections[0].data['collection.items--enquire-email'].value[0].text" class="enquire-btn">Enquire</a>
      <br/>
    </div>

  </section>
</template>

<script>
import Vue from 'vue'
import Config from 'src/config'
import skuItem from 'src/components/Collection__SKUs__Item'
import _find from 'lodash/find'
export default {
  name: 'CollectionSKUs',
  components: { skuItem },
  props: {
    slug: String,
    collections: Array,
    itemViewName: {
      type: String,
      default: 'Collection Items – Item Overlay'
    },
    options: {
      type: Object,
      default: () => ({ customOrders: true, isPurchase: false })
    }
  },
  data () {
    return {
      // products: false,
      cart: null,
      readMore: false
    }
  },

  metaInfo () {
    const title = this.collection ? this.collection.getText('collection.title') : 'Dovedale Design Studio'
    const description = this.collection ? this.collection.getText('collection.meta_description') : ''
    const metaKeywords = this.collection ? this.collection.getText('collection.meta_keywords') : ''
    const shareImage = this.collection && this.collection.data['collection.share_image'] && this.collection.data['collection.share_image'].value.main.url ? this.collection.data['collection.share_image'].value.main.url : ''

    // console.log('title', title)
    // console.log('description', description)
    // console.log('metaKeywords', metaKeywords)
    // console.log('shareImage', shareImage)
    // console.log(this.collection)

    return {
      meta: [
        {name: 'description', content: description},
        {name: 'keywords', content: metaKeywords},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        // {property: 'og:type', content: 'website'},
        {property: 'og:image', content: shareImage},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description},
        {name: 'twitter:image:src', content: shareImage},
        {itemprop: 'name', content: title},
        {itemprop: 'description', content: description},
        {itemprop: 'image', content: shareImage}
      ]
    }
  },

  computed: {
    collection () {
      return _find(this.collections, ['uid', this.slug])
    },
    shopCollectionId () {
      return this.collection && this.collection.getNumber('collection.shopify-collection-id')
    },
    products () {
      if (!this.shopCollectionId) return []

      // OLD WAY OF GETTING THE COLLECTION USES A FUNCTION (GETSHOPIFYID) FROM MAIN.JS THAT CONVERTS THE ID STRING WITH BTOA() TO A BASE64 STRING: BTOA(gid://shopify/' + type + '/' + id)
      // ---
      // NEW WAY OF GETTING THE COLLECTION USES THE ID STRING DIRECTLY BY MODIFYING SAME FUNCTION TO RETURN THE STRING WITHOUT BTOA(), SIMPLY: gid://shopify/' + type + '/' + id
      const shopCollection = _find(this.$store.state.shopCollections, ['id', Vue.getShopifyID(this.shopCollectionId, 'Collection')]) || {}

      return shopCollection.products || []
    },
    shortTitle () {
      return this.collection ? this.collection.getText('collection.title') : ''
    },
    title () {
      return this.collection.getText('collection.items--header')
    },
    text () {
      return this.collection.getStructuredText('collection.items--text').asHtml(Config.prismic.links)
    },
    email () {
      return this.collection.getText('collection.items--enquire-email')
    }
  },
  watch: {
    '$route' (to, from) {
      this.getCart() // update cart between overlays
    },
    collection () {
      this.updateMeta()
    },
    shopCollectionId () {
      this.getProducts()
    }
  },
  methods: {
    getCart () {
      // shopifyAPI.fetchRecentCart().then(cart => { this.cart = cart })
    },
    getProducts () {
      // retrives Shopify Colleciton by ID (includes products)
      const id = this.shopCollectionId
      if (id) this.$store.dispatch('getShopCollection', id)
    },
    updateMeta () {
      if (!this.collection) return false
      if (this.$route.meta.updateMetaTitle) {
        const title = 'Purchase ' + this.collection.getText('collection.title')
        Vue.updateMeta.setTitle(title)
      }
      // always update description
      const descrip = this.collection.getText('collection.meta_description')
      if (descrip) Vue.updateMeta.setDescription(descrip)
    }
  },
  created () {
    this.getProducts()
    // this.getProducts()
    this.getCart()
    this.updateMeta()
  }
}
</script>

<style lang="scss">
  @import '../style/variables';

  .collection--items{
    > header{
      max-width:40.5833125em;
      margin:0 auto 6.25em;
      box-sizing:content-box;
      padding:6.25em $gutter 0;
      h2{
        margin-bottom: 2.380952381em;
      }
    }
    > ul{
      list-style-type: none;
      width:calc(86.32812% + #{$gutter} * 2);
      margin:0 auto;
      padding:$gutter/2;
      display:flex;
      flex-wrap:wrap;
      justify-content: center;
      > li{
        width:calc(100% / 3);
        padding:$gutter/2;
      }
    }

    > footer{
      margin:6.25em auto;
      width:calc(86.32812%);
      padding:0 $gutter;
      .enquire-btn{
        width:calc(100%/3);
        margin:0 auto;
        @media (max-width:960px) {
          // &#enquireBtn{
            width:calc(100% * 2/3);
            > div{
              @include h7();
              padding:$gutter/2;
            }
          // }
        }
      }
    }
  }

  .enquire-btn{
    display:block;
    border-style:solid;
    height:7.8125em;
    @include vcenter_content($child:span);
    &:hover{
      background:$black;
      color:$white;
    }
  }
  #enquireBtn{
    position:relative;
    display:flex;
    align-items:center;
    justify-content: center;
    &:before{
      display:none;
    }
    > div{
      display:none;
      color:$white;
    }
    &:hover{
      > .label{
        display:none;
      }
      > div {
        display:block;
      }
    }
  }

  // Mobile
  @include on_mobile() {
    .collection--items{
      > header{
        width:auto;
        margin:0 auto $collectionMobile-blockMargin-ns;
        padding:$collectionMobile-blockMargin-ns $collectionMobile-textMargin-ew 0;
        h2{
          @include h6();
          margin-bottom: 1em;
        }
      }
      > ul{
        width: auto;
        padding:0 $gutter*2;
        > li{
          width:100%;
          padding:0;
          margin:$gutter 0;
        }
      }
      > footer{
        margin:3.375em auto;
        padding:0 $collectionMobile-textMargin-ew;
        width:auto;
        .enquire-btn{
          width:auto;
          min-height: 4.518em;
          @include h7();
        }
      }
    }
  }
  
// select #app with data-route="Purchase"
#app[data-route="Purchase"] {
  .collection--items > header {
    margin: 0 auto 1em
  }
  h2.h5 {
    margin-bottom: 1rem;
  }
  .readmore {
    margin-bottom: 2em;
    display: inline-block;
    // text-transform: uppercase !important;
    // font-size: 1rem;
  }
  .collection--items > footer {
    margin: 1em auto
  }
  .app__body {
    margin-bottom: 10rem;
  }
}
</style>



// WEBPACK FOOTER //
// Collection__SKUs.vue?deb9f932